import { z } from 'zod';
import { YearMonthSchema } from './ledger.js';
export const LedgerLockStatusSchema = z.object({
    ledgerId: z.uuid(),
    lockDate: z.iso.date().nullable(),
});
export const UpdateLedgerLockInputSchema = z.discriminatedUnion('operation', [
    z.strictObject({ operation: z.literal('lock-through'), month: YearMonthSchema }),
    z.strictObject({ operation: z.literal('unlock-from'), month: YearMonthSchema }),
]);
/** The same monotonic frontier calculation drives CLI previews and the writer. */
export function resolveLedgerLockDate(previous, input) {
    const firstDay = new Date(`${input.month}-01T00:00:00.000Z`);
    if (input.operation === 'lock-through')
        firstDay.setUTCMonth(firstDay.getUTCMonth() + 1);
    firstDay.setUTCDate(0);
    const target = firstDay.toISOString().slice(0, 10);
    if (input.operation === 'lock-through')
        return !previous || target > previous ? target : previous;
    return previous && target < previous ? target : previous;
}
